import { render, staticRenderFns } from "./MenuProfileMovil.vue?vue&type=template&id=129d9206"
import script from "./MenuProfileMovil.vue?vue&type=script&lang=js"
export * from "./MenuProfileMovil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports